export default __webpack_public_path__ + "static/media/polaroid09.29b8189b.jpg";